import { VehicleContractFillRequest } from '../model/VehicleContractFillRequest';
import { OptionValue } from '../../../browser/framework/service/options';

export type ValueOf<T> = T[keyof T];

export const vehicleContractFillRequestHandledApiErrors = {
    // Any kind of issue with token
    InvalidToken: 'invalid-token',
    // Token is valid but VehicleContractFillRequest linked to the token is removed from db.
    // Token is valid but
    NoLongerAvailable: 'no-longer-available',
    // Token is valid but user already submitted.
    AlreadySubmitted: 'already-submitted',
} as const;

export interface GetVehicleContractFillResponse {
    vehicleContractFillRequest: VehicleContractFillRequest;
    vehicleMakeOptions: OptionValue[];
}

export type PostFillRequestResponse =
    | { error: ValueOf<typeof vehicleContractFillRequestHandledApiErrors>; payload: null }
    | { error: null; payload: VehicleContractFillRequest };

export type GetFillRequestResponse =
    | { error: ValueOf<typeof vehicleContractFillRequestHandledApiErrors>; payload: null }
    | { error: null; payload: GetVehicleContractFillResponse };

export type VehicleContractFillRequestTokenValidationResponse =
    | { error: ValueOf<typeof vehicleContractFillRequestHandledApiErrors>; vehicleContractFillRequestId: null }
    | { error: null; vehicleContractFillRequestId: string };
